import { ReactNode } from "react";
import InactivateConfirmDialog from "@components/Dialog/InactivateConfirm";
import TableSettings from "@components/Table/Settings";
import type { TableDataProps } from "@components/Table/Settings";
import type { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { useT } from "@hooks";
import type { ISettingsCrudSelection } from "./useSettingsCrudPage";

export interface ISettingsCrudState {
  options: TableDataProps[];
  isLoading: boolean;
  deleteModal: boolean;
  setDeleteModal: (value: boolean) => void;
  optionSelected?: ISettingsCrudSelection;
  handleOpenCreate: () => void;
  handleOpenEdit: (
    id: number,
    name: string,
    type?: string,
    expenseType?: string,
    categoryName?: string,
    categoryId?: number
  ) => void;
  handleOpenDelete: (id: number, name: string) => void;
  handleActivate: (id: number) => void;
  handleInactivate: () => void;
}

interface Props {
  crud: ISettingsCrudState;
  translationPrefix: string;
  columnLabels: ColumnLabel;
  defaultColumnOrder: string[];
  children?: ReactNode;
}

const SettingsCrudPage = ({ crud, translationPrefix, columnLabels, defaultColumnOrder, children }: Props) => {
  const t = useT();

  return (
    <>
      <TableSettings
        data={crud.options}
        totalData={crud.options.length}
        columnLabels={columnLabels}
        defaultColumnOrder={defaultColumnOrder}
        viewType="TABLE"
        isLoading={crud.isLoading}
        onLoadMore={(res) => console.log(res)}
        openModal={() => crud.handleOpenCreate()}
        onEdit={crud.handleOpenEdit}
        onDelete={crud.handleOpenDelete}
        onActivateOption={(id) => crud.handleActivate(id)}
        onDeleteFile={() => {}}
        onGetFile={() => {}}
        onObservation={() => {}}
      />

      {children}

      <InactivateConfirmDialog
        show={crud.deleteModal}
        onClose={() => crud.setDeleteModal(false)}
        onConfirm={crud.handleInactivate}
        title={t(`${translationPrefix}.dialog.inactivateTitle`)}
        entityLabelForQuestion={t(`${translationPrefix}.entityLabel`)}
        entityName={crud.optionSelected?.name ?? ""}
        importantMessage={t(`${translationPrefix}.dialog.inactivateMessage`)}
      />
    </>
  );
};

export default SettingsCrudPage;
